"use strict";

const MuniPipesFilters = function () {
  const searchDbFields = ["name"];
  const searchFields = ["name"];

  var filterResourceDataHandler = (unfilteredData, filters, loadingScreen, smartFilters) =>
    smartFilters ? smartFilters.filter(unfilteredData, filters) : unfilteredData;

  var addGeoServerViewParams = function (params, filters) {
    GeoServerFilterFunctions.addSpatialFilterViewParams(params, filters);

    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("correctiveAction")) {
      params["correctiveAction"] = filters.correctiveAction.map((item) => `'${item}'`).join("\\,");
    }
    if (
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("correctiveAction") &&
      $('input[name="correctiveAction"][value="no-action"]').is(":checked")
    ) {
      params[`includeNoAction`] = true;
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("enforcementLevel")) {
      params["enforcementLevel"] = filters.enforcementLevel.map((item) => `'${item}'`).join("\\,");
    }
    if (
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("enforcementLevel") &&
      $('input[name="enforcementLevel"][value="null"]').is(":checked")
    ) {
      params[`includeNoActionLevel`] = true;
    }
    ResourceFilters.addDateParam(
      params,
      "routine",
      filters.routineDate?.from,
      filters.routineDate?.to,
    );
    ResourceFilters.addDateParam(
      params,
      "repair",
      filters.repairDate?.from,
      filters.repairDate?.to,
    );
  };

  var isOnlineDateFilterSet = function (filters) {
    return false;
  };

  var addGeoServerFilterQuery = function (queryStrings, filters) {
    if (filters.searchString) {
      queryStrings.push(
        GeoServerFilterFunctions.getSearchQuery(searchDbFields, filters.searchString),
      );
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("implementerType")) {
      GeoServerFilterFunctions.addFilterToGeoServerQuery(
        queryStrings,
        filters,
        "implementerType",
        "implementer_type",
      );
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("maintainedBy")) {
      GeoServerFilterFunctions.addFilterToGeoServerQuery(
        queryStrings,
        filters,
        "maintainedBy",
        "responsible_party_maintenance",
      );
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("lines")) {
      queryStrings = GeoServerFilterFunctions.yesNoNullGeoServerFilter(
        filters,
        "lines",
        queryStrings,
      );
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("phase")) {
      GeoServerFilterFunctions.addFilterToGeoServerQuery(queryStrings, filters, "phase", "phase");
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("ålandOwnership")) {
      GeoServerFilterFunctions.addFilterToGeoServerQuery(
        queryStrings,
        filters,
        "landOwnership",
        "property",
      );
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("consequenceOfFailure")) {
      GeoServerFilterFunctions.addFilterToGeoServerQuery(
        queryStrings,
        filters,
        "consequenceOfFailure",
        "cof_final_text",
      );
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("serviceType")) {
      GeoServerFilterFunctions.addFilterToGeoServerQuery(
        queryStrings,
        filters,
        "serviceType",
        "line_service_type",
      );
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("lined")) {
      if (filters.lined?.length !== undefined) {
        GeoServerFilterFunctions.yesNoNullGeoServerFilter(
          filters,
          "lined",
          queryStrings,
          "lined",
          filters.lined,
        );
      }
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("accessible")) {
      if (filters.accessible?.length !== undefined) {
        GeoServerFilterFunctions.yesNoNullGeoServerFilter(
          filters,
          "accessible",
          queryStrings,
          "accessible",
          filters.accessible,
        );
      }
    }
    if (filters.installDate) {
      GeoServerFilterFunctions.addDateQuery(
        queryStrings,
        "install_date",
        filters.installDate?.from,
        filters.installDate?.to,
      );
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("accessible")) {
      GeoServerFilterFunctions.addFilterToGeoServerQuery(queryStrings, filters, "shape", "shape");
    }

    const lengthWidthQueries = [];
    const diameterQuery = [];
    GeoServerFilterFunctions.addFeetAndInchesMinMaxMeasurmentQuery(
      "diameter",
      filters.diameterRange,
      "diameter_units",
      diameterQuery,
    );
    GeoServerFilterFunctions.addFeetAndInchesMinMaxMeasurmentQuery(
      "length",
      filters.lengthRange,
      "length_units",
      lengthWidthQueries,
    );
    GeoServerFilterFunctions.addFeetAndInchesMinMaxMeasurmentQuery(
      "width",
      filters.widthRange,
      "width_units",
      lengthWidthQueries,
    );
    const shapeDbColumnName = "shape";
    const indexOfShapeQuery = MeasurementMinMax.findIndexOfShapeQuery(
      queryStrings,
      shapeDbColumnName,
    );
    GeoServerFilterFunctions.createMinMaxMeasurmentCombinedQuery(
      queryStrings,
      lengthWidthQueries,
      diameterQuery,
      indexOfShapeQuery,
      shapeDbColumnName,
      filters,
    );
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("type")) {
      GeoServerFilterFunctions.addFilterToGeoServerQuery(
        queryStrings,
        filters,
        "type",
        "pipe_type",
      );
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("condition")) {
      GeoServerFilterFunctions.addMuniConditionFilterToGeoServerQuery(queryStrings, filters);
    }
  };

  var getFilterConfigs = function () {
    return {
      implementerType: "implementerType",
      maintainedBy: "maintainedBy",
      landOwnership: "landOwnership",
      type: "type",
      serviceType: "serviceType",
      phase: "phase",
      accessible: "accessible",
      condition: "condition",
      consequenceOfFailure: "cof",
      drainsToRw: ["drains_to_rws", "array"],
      drainsToC: ["drains_to_cs", "array"],
      catchmentName: ["catchment_names", "array"],
      catchments: ["catchment_names", "array"],
      zones: ["zone_names", "array"],
      maintenanceZones: ["zone_names", "array"],
      correctiveAction: ["correctiveAction", "array"],
      enforcementLevel: ["enforcementLevel", "array"],
      shape: "shape",
      lined: "lined",
      subGroups: "groupId",
      routineDate: (datum, filters) =>
        ResourceFilters.passDatesFilter(
          datum.routine,
          filters.routineDate?.from,
          filters.routineDate?.to,
        ),
      repairDate: (datum, filters) =>
        ResourceFilters.passDatesFilter(
          datum.repair,
          filters.repairDate?.from,
          filters.repairDate?.to,
        ),

      otherFilters: (datum, filters) => {
        return (
          ResourceFilters.passSearchStringFilter(datum, filters, searchFields) &&
          ResourceFilters.passIsoDateFilter(
            datum.installDate,
            filters.installDate?.from,
            filters.installDate?.to,
          )
        );
      },
    };
  };

  return {
    filterResourceDataHandler,
    isOnlineDateFilterSet,
    addGeoServerFilterQuery,
    addGeoServerViewParams,
    getFilterConfigs,
  };
};

module.exports = MuniPipesFilters();

const ResourceFilters = require("../filters/resourceFilters");
const GeoServerFilterFunctions = require("../mapFunctions/geoServerFilterFunctions");
const SmartFilterRegistry = require("../filters/smartFilterRegistry");
const MeasurementMinMax = require("../general/measurementMinMax");
